import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { format, addDays } from "date-fns";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import Modal from "react-modal";
import CommonFilterStructure from "../../../common-components/CommonFilterStructure";
import { fetchApiData } from "../../../../redux/reducers/commonApiSlice";
import { pt_sale_stat_detail } from "../../../../data/ApiEndpoints";
import ReactVortoxSpinner from "../../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../../payment-link-system/PaymentLinkTable";
import {
  convertStraight,
  convertThenFormat,
  currentDateOfTheMonth,
  formatDateTimezon,
} from "../../../common-data/Converts";
import ModalHeadAndClose from "../../../payouts-wtf/common/ModalHeadAndClose";
import PayoutsTable from "../../../components-bootstrap/PayoutsTable";
import TEPCard from "../common/TEPCard";
import { TotalPTMembers } from "../../../../exports/Images";

const PTSalesStats = ({
  filterType,
  userInfoData,
  selectedGym,
  startAndEndDate,
}) => {
  const dispatch = useDispatch();
  const { data, loading, error } = useSelector((state) => state.common);

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";

  const [openDateRanger, setOpenDateRanger] = useState(false);
  const initialRangeState = [
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 7),
      key: "selection",
    },
  ];
  const [rangeState, setRangeState] = useState(initialRangeState);
  const [isPage, setIsPage] = useState(0);
  const iniAllFilter = {
    selectedGym: selectedGym
      ? selectedGym
      : !isAdmin
      ? {
          label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
          value:
            userInfoData?.gym_id ||
            userInfoData?.user_id ||
            userInfoData?.uid ||
            "",
        }
      : "",
    selectedTrainer: "",
    selectedStartDate:
      filterType === "today"
        ? currentDateOfTheMonth
        : startAndEndDate?.startDate || "",
    selectedEndDate:
      filterType === "today"
        ? currentDateOfTheMonth
        : startAndEndDate?.endDate || "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    filter_type: filterType,
    view_type:
      filterType === "carry_over_partial_received" ||
      filterType === "carry_over_partial_pending"
        ? "past_carry_over"
        : (filterType === "partial_payment_received" ||
            filterType === "partial_payment_pending") &&
          (allFilters.selectedStartDate || allFilters.selectedEndDate)
        ? "between_dates"
        : "",
    gym_id: allFilters.selectedGym?.value || "",
    trainer_id: allFilters.selectedTrainer?.value || "",
    start_date: allFilters.selectedStartDate || "",
    end_date: allFilters.selectedEndDate || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const iniAllDatas = {
    fullDatas: {},
    partialData: {},
  };
  const [allDatas, setAllDatas] = useState(iniAllDatas);
  const iniModValues = {
    isModOpen: false,
    cardType: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  const closeModalValues = () => {
    setModValues(iniModValues);
  };

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
  };

  const handleDateRangeChange = (item) => {
    setRangeState([item?.selection]);

    const formattedStartDate = format(item?.selection?.startDate, "yyyy-MM-dd");
    const formattedEndDate = format(item?.selection?.endDate, "yyyy-MM-dd");

    setAllFilters({
      ...allFilters,
      selectedStartDate: formattedStartDate,
      selectedEndDate: formattedEndDate,
    });
  };

  const clearDateRanger = () => {
    setOpenDateRanger(false);
    setRangeState(initialRangeState);
    setAllFilters({
      ...allFilters,
      selectedStartDate: "",
      selectedEndDate: "",
    });
  };

  const onClickSearch = () => {
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
      setIsPage(0);
    }
  };

  function getCardDetail(filters) {
    dispatch(
      fetchApiData({
        method: "GET",
        endpoint: pt_sale_stat_detail,
        payload: {
          filters: filters,
        },
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    setAllFilters((prevs) => ({
      ...prevs,
      selectedGym: selectedGym
        ? selectedGym
        : !isAdmin
        ? {
            label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : "",
    }));
  }, [userInfoData?.gym_id]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
    }));
  }, [isPage]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      gym_id: allFilters.selectedGym?.value || "",
      trainer_id: allFilters.selectedTrainer?.value || "",
      start_date: allFilters.selectedStartDate || "",
      end_date: allFilters.selectedEndDate || "",
      view_type:
        filterType === "carry_over_partial_received" ||
        filterType === "carry_over_partial_pending"
          ? "past_carry_over"
          : (filterType === "partial_payment_received" ||
              filterType === "partial_payment_pending") &&
            (allFilters.selectedStartDate || allFilters.selectedEndDate)
          ? "between_dates"
          : "",
    }));
  }, [
    allFilters.selectedGym,
    allFilters.selectedTrainer,
    allFilters.selectedStartDate,
    allFilters.selectedEndDate,
  ]);

  useEffect(() => {
    getCardDetail(filters);
  }, [filters]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  useEffect(() => {
    if (
      data?.status &&
      (data?.full_data || data?.partial_data) &&
      !loading &&
      !error
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        fullDatas: data?.full_data || {},
        partialData: data?.partial_data || {},
      }));
    } else {
      setAllDatas(iniAllDatas);
    }
  }, [data, loading, error]);

  const tbColumns = [
    {
      dataField: "member_name",
      text: "Member",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">
            {row?.member_name || "NA"}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.member_mobile || "NA"}
              <br />
              {row?.member_email || "NA"}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "trainer_name",
      text: "Trainer / Exp Level",
      formatter: (cell, row) => (
        <span className="tb-data">
          {row?.trainer_name || "N/A"}
          <br />
          <small>({row?.experience_level || "N/A"})</small>
        </span>
      ),
    },
    {
      dataField: "gym_name",
      text: "gym name",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "plan_name",
      text: "plan name",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.plan_name || "NA"}</span>;
      },
    },
    {
      dataField: "is_partial",
      text: "Payment Type",
      formatter: (cell, row) => (
        <span
          className={`tb-data ${row?.is_partial === "true" ? "link" : ""}`}
          onClick={() =>
            row?.is_partial === "true"
              ? setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  cardType: "partial_details",
                  partialDetails: row?.payment_details || [],
                }))
              : null
          }
        >
          {row?.is_partial === "true" ? "Partial" : "Full"}
        </span>
      ),
    },
    {
      dataField: "price",
      text: "Total Amount",
      formatter: (cell, row) => (
        <span className="tb-data">₹{convertThenFormat(row?.price || 0)}</span>
      ),
    },
    {
      dataField: "total_partial_price",
      text: "Partial Amount",
      formatter: (cell, row) => (
        <span className="tb-data">
          {row?.is_partial === "true"
            ? `₹${convertThenFormat(row?.total_partial_price || 0)}`
            : "-"}
        </span>
      ),
    },
    {
      dataField: "total_online",
      text: "Online Amount",
      formatter: (cell, row) => (
        <span className="tb-data">
          ₹
          {convertThenFormat(
            row?.is_partial === "true"
              ? row?.partial_total_online
              : row?.total_online || 0
          )}
        </span>
      ),
    },
    {
      dataField: "total_cash",
      text: "Cash Amount",
      formatter: (cell, row) => (
        <span className="tb-data">
          ₹
          {convertThenFormat(
            row?.is_partial === "true"
              ? row?.partial_total_cash
              : row?.total_cash || 0
          )}
        </span>
      ),
    },
    {
      dataField: "session_status",
      text: "session status/duration",
      formatter: (cell, row) => (
        <span className="tb-data">
          {row?.session_status || "NA"}
          <br /> <small>({row?.duration || 0} Days)</small>
        </span>
      ),
    },
    {
      dataField: "date_added",
      text: "PT Date Added",
      formatter: (cell, row) => (
        <span className="tb-data minWidth100">
          {row?.date_added ? formatDateTimezon(row.date_added) : "-"}
        </span>
      ),
    },
    {
      dataField: "start_date",
      text: "Start Date",
      formatter: (cell, row) => (
        <span className="tb-data minWidth100">
          {row?.start_date ? formatDateTimezon(row.start_date) : "-"}
        </span>
      ),
    },
    {
      dataField: "expire_date",
      text: "Expire Date",
      formatter: (cell, row) => (
        <span className="tb-data minWidth100">
          {row?.expire_date ? formatDateTimezon(row.expire_date) : "-"}
        </span>
      ),
    },
    {
      dataField: "subscription_status",
      text: "PT Subscription status",
      formatter: (cell, row) => (
        <span
          className="tb-data minWidth100"
          style={{
            background:
              row?.subscription_status === "active" ? "#B4E7B9" : "#F6EFEF",
            color:
              row?.subscription_status === "active" ? "#0A701B" : "#F13434",
            borderRadius: "8px",
            padding: "5px 10px",
          }}
        >
          {row?.subscription_status || "NA"}
        </span>
      ),
    },
    {
      dataField: "regular_subscription_status",
      text: "Regular Subscription status",
      formatter: (cell, row) => (
        <span
          className="tb-data minWidth100"
          style={{
            background:
              row?.regular_subscription_status === "active"
                ? "#B4E7B9"
                : "#F6EFEF",
            color:
              row?.regular_subscription_status === "active"
                ? "#0A701B"
                : "#F13434",
            borderRadius: "8px",
            padding: "5px 10px",
          }}
        >
          {row?.regular_subscription_status || "NA"}
        </span>
      ),
    },
  ];

  const pmInfoColumns = [
    {
      dataField: "payment_created",
      text: "Payment Created",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.payment_created
              ? formatDateTimezon(row.payment_created)
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "date",
      text: "Schedule Date",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.date ? convertStraight(row.date) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "amount",
      text: "Amount",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.amount || 0) || 0}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius8"
            style={{
              background:
                row?.status === "pending"
                  ? "#FFEDC0"
                  : row?.status === "completed"
                  ? "#B4E7B9"
                  : "#F3DADA",
              color:
                row?.status === "pending"
                  ? "#171717"
                  : row?.status === "completed"
                  ? "#0A701B"
                  : "#D90000",
              borderRadius: "10px",
            }}
          >
            {row?.status || "NA"}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        onRequestClose={closeModalValues}
        ariaHideApp={false}
        isOpen={modValues.isModOpen}
      >
        <div className={`createNewCTOModalContainer mod-width-50p`}>
          <ModalHeadAndClose
            title={modValues.cardType?.replace(/_/g, " ")}
            onClose={closeModalValues}
          />

          {modValues.cardType === "partial_details" ? (
            <div className="fullWidthFlexCenter separatedTable">
              <PayoutsTable
                dataValues={modValues.partialDetails}
                columnsValues={pmInfoColumns}
              />
            </div>
          ) : null}
        </div>
      </Modal>

      <CommonFilterStructure
        from={"pt-sale-stat"}
        decryptedText={userInfoData}
        setFilters={setAllFilters}
        filters={allFilters}
        searchFilterApplied={searchFilterApplied}
        onClickSearch={onClickSearch}
        onClickReset={onResetFilters}
        openDateRanger={openDateRanger}
        handleDateRangeChange={handleDateRangeChange}
        setOpenDateRanger={setOpenDateRanger}
        rangeState={rangeState}
        clearDateRanger={clearDateRanger}
        isLoading={loading}
        isDisabledDate={filterType === "today"}
      />

      {filterType === "full_payment_received" && (
        <>
          <div className="cards-container cards-grid-container ptFlow">
            {allDatas.fullDatas?.stats &&
              Object.entries(allDatas.fullDatas?.stats).map(
                ([key, value], index) => (
                  <React.Fragment key={index}>
                    <TEPCard
                      filterType={key}
                      cardImg={TotalPTMembers}
                      total={key === "total" && value}
                      totalAmount={
                        key === "payment_received" &&
                        `₹${convertThenFormat(value || 0)}`
                      }
                      cardTitle={key?.replace(/_/g, " ")}
                      cardNotClickable={true}
                      isCardImgNotRequired={true}
                    />
                  </React.Fragment>
                )
              )}
          </div>
          <div className="fullWidthFlexCenter overflowAuto separatedTable">
            {loading ? (
              <ReactVortoxSpinner />
            ) : (
              <PaymentLinkTable
                tableData={
                  allDatas.fullDatas?.data?.length > 0
                    ? allDatas.fullDatas.data
                    : []
                }
                tableColumns={tbColumns}
                tablePagination={
                  allDatas.fullDatas?.pagination?.length > 0
                    ? allDatas.fullDatas.pagination
                    : []
                }
                isPage={isPage}
                setIsPage={(value) => setIsPage(value)}
              />
            )}
          </div>
        </>
      )}

      {(filterType === "partial_payment_received" ||
        filterType === "partial_payment_pending") && (
        <>
          <div className="cards-container cards-grid-container ptFlow">
            {allDatas.partialData?.stats &&
              Object.entries(allDatas.partialData?.stats).map(
                ([key, value], index) => (
                  <React.Fragment key={index}>
                    <TEPCard
                      filterType={key}
                      cardImg={TotalPTMembers}
                      total={key === "total" && value}
                      totalAmount={
                        (key === "payment_received" ||
                          key === "payment_pending") &&
                        `₹${convertThenFormat(value || 0)}`
                      }
                      cardTitle={key?.replace(/_/g, " ")}
                      cardNotClickable={true}
                      isCardImgNotRequired={true}
                    />
                  </React.Fragment>
                )
              )}
          </div>
          <div className="fullWidthFlexCenter overflowAuto separatedTable">
            {loading ? (
              <ReactVortoxSpinner />
            ) : (
              <PaymentLinkTable
                tableData={
                  allDatas.partialData?.data?.length > 0
                    ? allDatas.partialData.data
                    : []
                }
                tableColumns={tbColumns}
                tablePagination={
                  allDatas.partialData?.pagination?.length > 0
                    ? allDatas.partialData.pagination
                    : []
                }
                isPage={isPage}
                setIsPage={(value) => setIsPage(value)}
              />
            )}
          </div>
        </>
      )}

      {(filterType === "total_sales" || filterType === "today") && (
        <div className="ure-sr-or mt30">
          <Tabs>
            <TabList>
              <Tab>Full Payments</Tab>
              <Tab>Partial Payments</Tab>
            </TabList>

            <TabPanel>
              <div className="cards-container cards-grid-container ptFlow">
                {allDatas.fullDatas?.stats &&
                  Object.entries(allDatas.fullDatas?.stats).map(
                    ([key, value], index) => (
                      <React.Fragment key={index}>
                        <TEPCard
                          filterType={key}
                          cardImg={TotalPTMembers}
                          total={key === "total" && value}
                          totalAmount={
                            key === "payment_received" &&
                            `₹${convertThenFormat(value || 0)}`
                          }
                          cardTitle={key?.replace(/_/g, " ")}
                          cardNotClickable={true}
                          isCardImgNotRequired={true}
                        />
                      </React.Fragment>
                    )
                  )}
              </div>

              <div className="fullWidthFlexCenter overflowAuto separatedTable">
                {loading ? (
                  <ReactVortoxSpinner />
                ) : (
                  <PaymentLinkTable
                    tableData={
                      allDatas.fullDatas?.data?.length > 0
                        ? allDatas.fullDatas.data
                        : []
                    }
                    tableColumns={tbColumns}
                    tablePagination={
                      allDatas.fullDatas?.pagination?.length > 0
                        ? allDatas.fullDatas.pagination
                        : []
                    }
                    isPage={isPage}
                    setIsPage={(value) => setIsPage(value)}
                  />
                )}
              </div>
            </TabPanel>
            <TabPanel>
              <div className="cards-container cards-grid-container ptFlow">
                {allDatas.partialData?.stats &&
                  Object.entries(allDatas.partialData?.stats).map(
                    ([key, value], index) => (
                      <React.Fragment key={index}>
                        <TEPCard
                          filterType={key}
                          cardImg={TotalPTMembers}
                          total={key === "total" && value}
                          totalAmount={
                            (key === "payment_received" ||
                              key === "payment_pending") &&
                            `₹${convertThenFormat(value || 0)}`
                          }
                          cardTitle={key?.replace(/_/g, " ")}
                          cardNotClickable={true}
                          isCardImgNotRequired={true}
                        />
                      </React.Fragment>
                    )
                  )}
              </div>

              <div className="fullWidthFlexCenter overflowAuto separatedTable">
                {loading ? (
                  <ReactVortoxSpinner />
                ) : (
                  <PaymentLinkTable
                    tableData={
                      allDatas.partialData?.data?.length > 0
                        ? allDatas.partialData.data
                        : []
                    }
                    tableColumns={tbColumns}
                    tablePagination={
                      allDatas.partialData?.pagination?.length > 0
                        ? allDatas.partialData.pagination
                        : []
                    }
                    isPage={isPage}
                    setIsPage={(value) => setIsPage(value)}
                  />
                )}
              </div>
            </TabPanel>
          </Tabs>
        </div>
      )}
    </>
  );
};

export default PTSalesStats;
